"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _SimpleRule = _interopRequireDefault(require("./SimpleRule"));
var _RuleGroup = _interopRequireDefault(require("./RuleGroup"));
var _loader = require("../loader");
var _helpers = require("./helpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RulesBuilder = /*#__PURE__*/function (_React$Component) {
  function RulesBuilder(props) {
    var _this;
    _classCallCheck(this, RulesBuilder);
    _this = _callSuper(this, RulesBuilder, [props]);
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_this, "handleClickOutside", function () {
      _this.setState({
        selectedElement: ''
      });
    });
    _defineProperty(_this, "onRuleChange", function (_ref, pathKeys, variableOperands) {
      var variable = _ref.variable,
        operator = _ref.operator,
        values = _ref.values,
        uid = _ref.uid;
      var rulesCopy = R.clone(_this.props.rules);
      var newRules;
      if (pathKeys.length > 0) {
        var parentGroup = _this.getRuleObjectToChange(rulesCopy, pathKeys);
        parentGroup.element.eligibilityRows.splice(parentGroup.position, 1, _objectSpread(_objectSpread({}, (0, _helpers.getSimpleRuleValues)(variable, operator, values, variableOperands)), {}, {
          uid: uid
        }));
        newRules = _objectSpread({}, rulesCopy);
      } else {
        newRules = _objectSpread(_objectSpread({}, (0, _helpers.getSimpleRuleValues)(variable, operator, values, variableOperands)), {}, {
          uid: uid
        });
      }
      _this.props.onChange(newRules, {
        rule: {
          variable: variable,
          operator: operator,
          values: values,
          uid: uid
        }
      });
    });
    _defineProperty(_this, "onSelectElement", function (uid) {
      var selectedElement = _this.state.selectedElement;
      if (uid === selectedElement) return;
      _this.setState({
        selectedElement: uid
      });
    });
    _defineProperty(_this, "onDuplicateGroup", function (pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
      var clonedGroup = R.clone(parentGroup.element.eligibilityRows[parentGroup.position]);
      parentGroup.element.eligibilityRows.splice(parentGroup.position + 1, 0, (0, _helpers.addUidsToRules)(clonedGroup));
      _this.props.onChange(newRules);
    });
    _defineProperty(_this, "onDuplicateRule", function (pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
      var clonedRule = R.clone(parentGroup.element.eligibilityRows[parentGroup.position]);
      clonedRule.uid = (0, _uuid.v4)();
      parentGroup.element.eligibilityRows.splice(parentGroup.position + 1, 0, clonedRule);
      _this.props.onChange(newRules);
    });
    _defineProperty(_this, "onDeleteElement", function (type, pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var pathKeysCopy = R.clone(pathKeys);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeysCopy);
      parentGroup.element.eligibilityRows.splice(parentGroup.position, 1);

      // MIO this really needs to be abstracted away and properly unit tested.
      // if after deleting the element the resulting group has only one item remaining
      if (parentGroup.element.eligibilityRows.length === 1 && pathKeys.length > 0) {
        var remainingElement = parentGroup.element.eligibilityRows.pop();
        // if the parent group is the root group we should allow it to have one element */
        if (newRules === parentGroup.element) {
          // if remaining element is a group it should replace the parent group
          if (remainingElement.eligibilityRowsOperator) {
            Object.assign(parentGroup.element, remainingElement);
            // if remaining element is not a group it should be placed in a group without operator
          } else {
            parentGroup.element.eligibilityRows.push(remainingElement);
            delete parentGroup.element.eligibilityRowsOperator;
          }
        } else {
          Object.assign(parentGroup.element, remainingElement);

          /* if the remaining element is not a group then we should transform the parent group into a
            simple rule
          */
          if (remainingElement.eligibilityRows === undefined) {
            delete parentGroup.element.eligibilityRows;
            delete parentGroup.element.eligibilityRowsOperator;
          } else {
            Object.assign(parentGroup.element, remainingElement);
            pathKeys.shift();
            pathKeys.pop();
            var grandParentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
            R.path(['element', 'eligibilityRows'], grandParentGroup).forEach(function (element, index) {
              if (grandParentGroup.element.eligibilityRowsOperator === R.prop('eligibilityRowsOperator', element)) {
                var _R$path;
                (_R$path = R.path(['element', 'eligibilityRows'], grandParentGroup)).splice.apply(_R$path, [index, 1].concat(_toConsumableArray(element.eligibilityRows)));
              }
            });
          }
        }
      } else if (parentGroup.element.eligibilityRows.length === 0 || pathKeys.length === 0) {
        newRules = {};
      }
      _this.props.onChange(newRules);
    });
    _defineProperty(_this, "onAddNewRule", function (type, pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var emptyRule = R.clone(_helpers.emptySimpleRule);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
      if (!parentGroup.element.eligibilityRowsOperator || parentGroup.element.eligibilityRowsOperator === type) {
        parentGroup.element.eligibilityRows.splice(parentGroup.position + 1, 0, _objectSpread(_objectSpread({}, emptyRule), {}, {
          uid: (0, _uuid.v4)()
        }));
        parentGroup.element.eligibilityRowsOperator = type;
      } else {
        parentGroup.element.eligibilityRows[parentGroup.position] = {
          eligibilityRowsOperator: type,
          eligibilityRows: [parentGroup.element.eligibilityRows[parentGroup.position], _objectSpread(_objectSpread({}, emptyRule), {}, {
            uid: (0, _uuid.v4)()
          })],
          uid: (0, _uuid.v4)()
        };
      }
      _this.props.onChange(newRules);
    });
    _defineProperty(_this, "getRuleObjectToChange", function (element, pathKeys) {
      var parentDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var position = pathKeys.shift();
      if (pathKeys.length >= parentDepth) {
        return _this.getRuleObjectToChange(element.eligibilityRows[position], pathKeys);
      }
      return {
        element: element,
        position: position
      };
    });
    _defineProperty(_this, "renderSimpleRule", function (id, rule) {
      var pathKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var parentOperator = arguments.length > 3 ? arguments[3] : undefined;
      var labels = arguments.length > 4 ? arguments[4] : undefined;
      var hideMenu = arguments.length > 5 ? arguments[5] : undefined;
      var _this$props = _this.props,
        variableOptions = _this$props.variableOptions,
        operatorOptions = _this$props.operatorOptions,
        onLookupData = _this$props.onLookupData,
        lookUpValues = _this$props.lookUpValues,
        errors = _this$props.errors,
        searchableAction = _this$props.searchableAction,
        type = _this$props.type;
      var isLinkedRewardsEligibility = _this.state.isLinkedRewardsEligibility;
      var computedId = "".concat(id).concat(pathKeys.join('-'));
      if (R.isEmpty(variableOptions || R.isEmpty(operatorOptions) || R.isEmpty(lookUpValues))) {
        return /*#__PURE__*/_react["default"].createElement(_loader.PageLoader, {
          key: (0, _uuid.v4)(),
          pastDelay: true
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_SimpleRule["default"], {
        disabled: R.prop('disabled', _this.props),
        className: "simple-rule",
        key: rule.uid || id,
        pathKeys: pathKeys,
        id: computedId,
        onClick: function onClick(e) {
          e.stopPropagation();
          _this.onSelectElement(rule.uid);
        },
        onRuleChange: _this.onRuleChange,
        onDuplicate: _this.onDuplicateRule,
        onDelete: _this.onDeleteElement,
        onAddNew: _this.onAddNewRule,
        operatorOptions: operatorOptions,
        rule: rule,
        parentOperator: parentOperator,
        isSelected: rule.uid === _this.state.selectedElement,
        variableOptions: variableOptions,
        lookUpValues: lookUpValues,
        onLookupData: onLookupData,
        isDuplicateDisabled: parentOperator === 'IF',
        labels: _objectSpread(_objectSpread({}, labels), {}, {
          LEFT_OPERAND_PLACEHOLDER: isLinkedRewardsEligibility ? labels.LINKED_REWARDS_VARIABLE_PLACEHOLDER : labels.ELIGIBILITY_VARIABLE_PLACEHOLDER
        }),
        errors: R.path([type, rule.uid], errors),
        hideMenu: hideMenu,
        searchableAction: searchableAction,
        hasDisjunction: !isLinkedRewardsEligibility
      });
    });
    _defineProperty(_this, "renderRuleGroup", function (_ref2) {
      var id = _ref2.id,
        uid = _ref2.uid,
        operator = _ref2.operator,
        rules = _ref2.rules,
        _ref2$pathKeys = _ref2.pathKeys,
        pathKeys = _ref2$pathKeys === void 0 ? [] : _ref2$pathKeys,
        labels = _ref2.labels;
      var computedId = "".concat(id).concat(pathKeys.join('-'));
      var isFirstGroup = pathKeys.length === 0;
      var disableFirstGroupDelete = _this.props.disableFirstGroupDelete;
      var groupProps = {
        groupOperator: operator || 'IF'
      };
      if (groupProps.groupOperator === 'IF') {
        groupProps.isMenuHidden = true;
        groupProps.className = 'if-group';
        groupProps.onClick = function (e) {
          e.stopPropagation();
          _this.onSelectElement(rules[0].uid);
        };
        groupProps.isSelected = rules[0].uid === _this.state.selectedElement;
      }
      if (isFirstGroup && disableFirstGroupDelete) {
        groupProps.isMenuHidden = true;
      }
      return /*#__PURE__*/_react["default"].createElement(_RuleGroup["default"], _extends({
        disabled: R.prop('disabled', _this.props),
        key: uid,
        uid: uid,
        id: computedId,
        onClick: function onClick(e) {
          e.stopPropagation();
          _this.onSelectElement(uid);
        },
        onDuplicate: _this.onDuplicateGroup,
        onDelete: _this.onDeleteElement,
        isDuplicateDisabled: isFirstGroup,
        isSelected: uid === _this.state.selectedElement,
        pathKeys: pathKeys,
        labels: labels
      }, groupProps), rules.map(function (rule, key) {
        if (rule.eligibilityRows) {
          return _this.renderRuleGroup({
            id: id,
            uid: rule.uid,
            operator: rule.eligibilityRowsOperator,
            rules: rule.eligibilityRows,
            pathKeys: [].concat(_toConsumableArray(pathKeys), [key]),
            labels: labels
          });
        }
        return _this.renderSimpleRule("".concat(id), rule, [].concat(_toConsumableArray(pathKeys), [key]), groupProps.groupOperator, labels, isFirstGroup && disableFirstGroupDelete);
      }));
    });
    var _isLinkedRewardsEligibility = props.type === 'additionalRewardsEligibility';
    _this.state = {
      selectedElement: '',
      isLinkedRewardsEligibility: _isLinkedRewardsEligibility
    };
    return _this;
  }
  _inherits(RulesBuilder, _React$Component);
  return _createClass(RulesBuilder, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        id = _this$props2.id,
        labels = _this$props2.labels,
        rules = _this$props2.rules;
      return rules && this.renderRuleGroup({
        id: id,
        uid: rules.uid,
        operator: rules.eligibilityRowsOperator,
        rules: rules.eligibilityRows,
        pathKeys: [],
        labels: labels
      });
    }
  }]);
}(_react["default"].Component);
RulesBuilder.propTypes = {
  searchableAction: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  variableOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  operatorOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  lookUpValues: _propTypes["default"].shape({}),
  onLookupData: _propTypes["default"].func,
  onChange: _propTypes["default"].func.isRequired,
  rules: _propTypes["default"].shape({
    uid: _propTypes["default"].string,
    eligibilityRowsOperator: _propTypes["default"].string,
    eligibilityRows: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  /** A list of error objects for all the simple rules */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].shape({})]),
  /** CMS labels */
  labels: _propTypes["default"].shape({}),
  disableFirstGroupDelete: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(['additionalRewardsEligibility', 'eligibility'])
};
RulesBuilder.defaultProps = {
  disabled: false,
  lookUpValues: null,
  searchableAction: function searchableAction() {
    return Promise.resolve({});
  },
  onLookupData: function onLookupData() {},
  errors: {},
  labels: {},
  disableFirstGroupDelete: false,
  type: 'eligibility'
};
var _default = exports["default"] = (0, _reactClickOutside["default"])(RulesBuilder);